import { axiosClient } from "~/js/network/axiosClient";
import { getWorkspacesStore } from "~/solidJs/entities/WorkspaceListEntity/models/wrokspaceListContext";
import * as network from "../network/network-handler";
export interface Description {
	[key: string]: {
		token: string;
		creation_ts: string;
		description: string;
	};
}
export interface Dreambooth {
	description: Description;
	node_group_id: number;
	model_version: number;
	trained_on: string;
	deleted_at: null | string;
	id: number;
	user_id: number;
	model: null | string;
	weights: string;
	task_id: number;
	model_type: string;
	creation_ts: string;
}
export type DreamBoothModelListItem = {
	Dreambooth: Dreambooth;
	is_blocked: boolean;
};
type TokenData = {
	token: string;
	description: string;
	link_to_model: string;
	seed: number;
	max_train_steps: number;
	network_dim: number;
	network_alpha: number;
	dataset_repeats: number;
};
type LoraParams = {
	[key: string]: TokenData;
};

export type LoraModelListItem = {
	user_id: number;
	path: string;
	model_version: string;
	model_type: string;
	task_id: number;
	params: LoraParams;
	id: number;
	node_group_id: number;
	creation_ts: string; // Using string to store the ISO 8601 date
};

export type DreamBoothModelList = DreamBoothModelListItem[];
export async function getUserDreamboothModels(idGlobal: string) {
	const endPoint = "api/v2/nodes/dreambooth_user";

	const url = endPoint;
	console.log(`GET-request url with query: ${url}`);
	const sharingLink = getWorkspacesStore().activeWorkspaceLink;
	const response = await axiosClient.axiosClient.get<DreamBoothModelList>(url, {
		headers: network.standardHeaders(),
		params: {
			id_global: idGlobal,
			...(sharingLink ? { sharing_link: sharingLink } : {})
		}
	});

	const dbDreamBoothModels = response.data;
	const userDreamBoothModels = dbDreamBoothModels.reduce(
		(prev, dbModel) => {
			const model_type = dbModel.Dreambooth.model_type;
			if (!(model_type in prev)) {
				prev[model_type] = [];
			}
			let modelName: number | string = dbModel.Dreambooth.id;
			if ("0" in dbModel.Dreambooth.description) {
				modelName = dbModel.Dreambooth.description["0"].token;
			}

			prev[model_type].push({
				name: modelName,
				value: dbModel.Dreambooth.id,
				isDisabled: !!dbModel.is_blocked
			});
			return prev;
		},
		{} as Record<string, { name: string | number; value: number; isDisabled: boolean }[]>
	);

	return userDreamBoothModels;
}
export async function getUserLorasModels(idGlobal: string) {
	const endPoint = "api/v2/nodes/train_models";

	const url = endPoint;
	console.log(`GET-request url with query: ${url}`);
	const response = await axiosClient.axiosClient.get<LoraModelListItem[]>(url, {
		headers: network.standardHeaders(),
		params: {
			id_global: idGlobal
		}
	});

	const dbDreamBoothModels = response.data;
	const userDreamBoothModels = dbDreamBoothModels.map((dbModel) => {
		let modelName: number | string = "Default name";
		if (dbModel.params && "0" in dbModel.params) {
			modelName = dbModel.params["0"].token;
		}

		return {
			name: modelName,
			value: dbModel.path,
			isDisabled: false
		};
	});

	return userDreamBoothModels;
}
